
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M2.585 10.668c-.443.355-.684.662-.862 1.069a2.7 2.7 0 0 0-.214 1.31c.037.45.184.887.426 1.266.241.38.57.688.953.895.384.208.81.308 1.235.29a2.3 2.3 0 0 0 1.192-.391c.357-.239.647-.573.841-.97.195-.397.285-.857.28-1.296l6.561.004m-1.985-8.428c-.072-.578-.206-.95-.454-1.314a2.53 2.53 0 0 0-.977-.85 2.48 2.48 0 0 0-2.479.17 2.55 2.55 0 0 0-.857.973 2.6 2.6 0 0 0 .11 2.523c.231.375.567.686.933.9l-3.284 5.944m7.887 2.412c.515.224.89.289 1.315.246a2.43 2.43 0 0 0 1.191-.46c.355-.26.644-.61.836-1.02.193-.408.284-.86.264-1.311a2.7 2.7 0 0 0-.377-1.263 2.43 2.43 0 0 0-.92-.885 2.3 2.3 0 0 0-1.223-.277 2.6 2.6 0 0 0-1.213.395L8.487 4.652m4.767 8.63a.53.53 0 0 0 .181-.706.48.48 0 0 0-.674-.188.53.53 0 0 0-.18.705.48.48 0 0 0 .673.189m-4.52-8.183a.53.53 0 0 0 .18-.705.48.48 0 0 0-.674-.189.53.53 0 0 0-.18.705.48.48 0 0 0 .673.19m-4.559 8.156a.53.53 0 0 0 .18-.705.48.48 0 0 0-.673-.189.53.53 0 0 0-.18.705.48.48 0 0 0 .673.19"}})])
          )
        }
      }
    